import ArrowIcon from "@/components/SVGComponents/ArrowIcon";
import LocationPinIcon from "@/components/SVGComponents/LocationPinIcon";
import type { Chapter } from "@/services/api/chapters";
import styles from "./ChapterCard.module.scss";

interface ChapterCardProps {
  chapter: Chapter;
  onManage: (chapter: Chapter) => void;
}

// No "neighbourhoods" field exists on the real Chapter (GET /admin/chapters
// only returns id/name/venues/membersCount/eventsCount/waitlistCount/
// leadUser) — the Figma mock's neighbourhood line under the city name is
// dropped rather than left showing stale hardcoded copy.
const ChapterCard = ({ chapter, onManage }: ChapterCardProps) => (
  <div className={styles.card}>
    <div className={styles.banner}>
      <LocationPinIcon className={styles.pinIcon} />
      <h3 className={styles.city} title={chapter.name}>
        {chapter.name}
      </h3>
    </div>

    <div className={styles.body}>
      <div className={styles.statsRow}>
        <div className={styles.stat}>
          <span className={styles.statValue}>{chapter.membersCount}</span>
          <span className={styles.statLabel}>Members</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.statValue}>{chapter.eventsCount}</span>
          <span className={styles.statLabel}>Events</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.statValue}>{chapter.waitlistCount}</span>
          <span className={styles.statLabel}>Waitlist</span>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.leadBlock}>
          <span className={styles.leadLabel}>Chapter lead</span>
          <span
            className={chapter.leadUser ? styles.leadName : styles.leadUnappointed}
            title={chapter.leadUser ?? "Not appointed"}
          >
            {chapter.leadUser ?? "Not appointed"}
          </span>
        </div>
        <button type="button" className={styles.manageLink} onClick={() => onManage(chapter)}>
          MANAGE
          <ArrowIcon className={styles.manageIcon} />
        </button>
      </div>
    </div>
  </div>
);

export default ChapterCard;
